import { useEffect } from 'react';
import { toast } from 'react-toastify';
import IconToast from '../../../components/NewToast';
import { CLIENT_NOTES_SAVE_FAILED_EVENT } from './clientNotesStore';

type IntlLike = { formatMessage: (descriptor: { id: string }) => string };

/**
 * A failed adviser-notes write (clientNotesStore) says so the way a failed fact
 * write does — same message, same toastId, so when two surfaces listen at once
 * (ClientV2's bridge and Smart IDEA opened from it) it still shows once.
 */
export const useNotesSaveFailedToast = (intl: IntlLike) => {
  useEffect(() => {
    const onFailed = () =>
      toast.error(IconToast('error', intl.formatMessage({ id: 'clientv2-fact-save-failed' })), {
        className: 'new-toast',
        toastId: 'clientv2-fact-save-failed'
      });
    window.addEventListener(CLIENT_NOTES_SAVE_FAILED_EVENT, onFailed);
    return () => window.removeEventListener(CLIENT_NOTES_SAVE_FAILED_EVENT, onFailed);
  }, [intl]);
};
